<template >
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-if="roleElligibleView()" v-bind:to="{ name: 'student/index' }">
                                Siswa
                            </router-link>
                            <template v-else>
                                Siswa
                            </template>
                        </li>
                        <li class="breadcrumb-item font-weight-medium">
                            <router-link v-if="roleElligibleView()" v-bind:to="{ name: 'student/view', params: {id: student.userID} }">
                                {{ student.user.name }}
                            </router-link>
                            <template v-else>
                                {{ student.user.name }}
                            </template>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Laporan Nilai Siswa
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 col-lg-12 mb-4">
                <div class="card shadow-sm border-0 h-100">
                    <div class="card-header background-primary">
                        <div class="row justify-content-end">
                            <div class="col">
                                <span class="h4 font-weight-medium text-white mb-0">
                                    Ringkasan Data Siswa
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="card-body px-5">
                        <div class="row">
                            <div class="col-auto">
                                <div v-bind:style="'background-image: url(' + student.imageUrl +')'" class="user-avatar rounded-circle"></div>
                            </div>
                            <div class="col ml-2">
                                <div class="row mb-1 align-items-center">
                                    <div class="col-sm-6 col-12 p-1">
                                        <label class="font-weight-medium mb-0 h4 form-divider">
                                            Nama Lengkap
                                        </label>
                                    </div>
                                    <div class="col-sm-6 col-12 px-1">
                                        <h4 class="mb-0 font-weight-medium text-loading">
                                            {{ student.user.name }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-sm-6 col-12 p-1">
                                        <label class="font-weight-medium mb-0 h4 form-divider">
                                            Nomor Peserta BTA
                                        </label>
                                    </div>
                                    <div class="col-sm-6 col-12 px-1">
                                        <h4 class="mb-0 font-weight-medium text-loading">
                                            {{ student.identity }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-sm-6 col-12 p-1">
                                        <label class="font-weight-medium mb-0 h4 form-divider">
                                            Cabang BTA
                                        </label>
                                    </div>
                                    <div class="col-sm-6 col-12 px-1">
                                        <h4 class="mb-0 font-weight-medium text-loading">
                                            {{ student.branch.name }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-sm-6 col-12 p-1">
                                        <label class="font-weight-medium mb-0 h4 form-divider">
                                            Asal Sekolah
                                        </label>
                                    </div>
                                    <div class="col-sm-6 col-12 px-1">
                                        <h4 class="mb-0 font-weight-medium text-loading">
                                            {{ student.school.name }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-sm-6 col-12 p-1">
                                        <label class="font-weight-medium mb-0 h4 form-divider">
                                            Kelas
                                        </label>
                                    </div>
                                    <div class="col-sm-6 col-12 px-1">
                                        <h4 class="mb-0 font-weight-medium text-loading">
                                            {{ student.btaGrade.name }}
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-sm-6 col-12 p-1">
                                        <label class="font-weight-medium mb-0 h4 form-divider">
                                            Pola Semester 1
                                        </label>
                                    </div>
                                    <div class="col-sm-6 col-12 px-1">
                                        <template v-if="student.studentVerified && student.studentVerified.pattern">
                                            <h4 class="mb-0 font-weight-medium text-loading">
                                                {{ student.studentVerified.pattern.periods.map(period => $moment.weekdays(period.day)).join(", ") }}
                                            </h4>
                                        </template>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-sm-6 col-12 p-1">
                                        <label class="font-weight-medium mb-0 h4 form-divider">
                                            Pola Semester 2
                                        </label>
                                    </div>
                                    <div class="col-sm-6 col-12 px-1">
                                        <template v-if="student.studentVerified && student.studentVerified.secondPattern">
                                            <h4 class="mb-0 font-weight-medium text-loading">
                                                {{ student.studentVerified.secondPattern.periods.map(period => $moment.weekdays(period.day)).join(", ") }}
                                            </h4>
                                        </template>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-sm-6 col-12 p-1">
                                        <label class="font-weight-medium mb-0 h4 form-divider">
                                            Nilai TO PTN Tertinggi
                                        </label>
                                    </div>
                                    <div class="col-sm-6 col-12 px-1">
                                        <h4 class="mb-0 font-weight-medium text-loading">
                                            <span v-if="student.maxGroupScore" class="text-loading">{{ student.maxGroupScore }}%</span>
                                            <i class="fa fa-minus" v-else></i>
                                        </h4>
                                    </div>
                                </div>
                                <div class="row mb-1 align-items-center">
                                    <div class="col-sm-6 col-12 p-1">
                                        <label class="font-weight-medium mb-0 h4 form-divider">
                                            Nilai TO UN Tertinggi
                                        </label>
                                    </div>
                                    <div class="col-sm-6 col-12 px-1">
                                        <h4 class="mb-0 font-weight-medium text-loading">
                                            <span v-if="student.maxSubjectScore" class="text-loading">{{ student.maxSubjectScore }}</span>
                                            <i class="fa fa-minus" v-else></i>
                                        </h4>
                                    </div>
                                </div>
				<div class="row mb-1 align-items-center">
                                    <div class="col-sm-6 col-12 p-1">
                                        <label class="font-weight-medium mb-0 h4 form-divider">
                                            Jumlah Akses Materi Belajar
                                        </label>
                                    </div>
                                    <div class="col-sm-6 col-12 px-1">
                                        <h4 class="mb-0 font-weight-medium text-loading">
                                            {{ student.totalLog }} 
                                        </h4>
                                    </div>
                                </div>
                                <hr />
                                <div class="row mb-1 align-items-center" v-for="status in statuses">
                                    <div class="col-sm-6 col-12 p-1">
                                        <label class="font-weight-medium mb-0 h4 form-divider">
                                            {{ status.name }}
                                        </label>
                                    </div>
                                    <div class="col-sm-6 col-12 px-1">
                                        <h4 class="mb-0 font-weight-medium text-loading">
                                            {{ student[status.name] }} dari {{ student.totalAttendance }} sesi
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-12">
                <div class="row">
                    <template v-for="donut in graphData.donuts">
                        <div class="col-12 col-xl-12 col-md-6 mb-4" v-if="donut.series[0].data.length">
                            <div class="card shadow-sm border-0">
                                <div class="card-header background-primary">
                                    <div class="row justify-content-end">
                                        <div class="col">
                                            <span class="h4 font-weight-medium text-white mb-0">
                                                Rekap Kehadiran Siswa {{ donut.series[0].name }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-body px-5">
                                    <div class="position-relative graph-wrapper">
                                        <div class="w-100 donut-chart">
                                            <IEcharts v-bind:option="donut" resizable />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col mb-5">
                <div class="slim-scroll scroll-x" v-dragscroll>
                    <div class="card shadow-sm mb-4 border-0" style="min-width: 100%;" v-bind:style="{width: (250 * graphData.bar.xAxis[0].data.length) + 'px'}">
                        <div class="card-header background-primary">
                            <div class="row justify-content-end">
                                <div class="col">
                                    <span class="h4 font-weight-medium text-white mb-0">
                                        Grafik Nilai TO
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="card-body px-5">
                            <div style="height: 600px;">
                                <IEcharts v-bind:option="graphData.bar" resizable />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div class="row justify-content-end">
                    <div class="col mb-2">
                        <h3 class="font-weight-bold">Laporan Nilai TO Siswa</h3>
                    </div>
                    <div class="col-auto ml-auto">
                        <template v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isDirector || profile.employee.isManager || profile.employee.isMentor || profile.employee.isTeacher))">
                            <router-link v-bind:to="{ name: 'student/tryout/recommendation/index', params: {id: student.userID, type: courseCategory.id} }" class="btn btn-outline-danger btn-sm ml-2" v-for="courseCategory in courseCategories" v-bind:key="courseCategory.id">
                                Rekomendasi Prodi {{ courseCategory.name }}
                            </router-link>
                        </template>
                        <button class="btn btn-danger btn-sm ml-2" type="button" v-on:click="print()" v-if="false">
                            Cetak Laporan Nilai
                        </button>
                    </div>
                </div>
                <div class="row" v-for="tryout in tryouts">
                    <div class="col mb-3">
                        <div class="slim-scroll scroll-x" v-dragscroll="!isMobile()">
                            <div class="row">
                                <div class="col-auto">
                                    <div class="row">
                                        <div class="col">
                                            <div class="card shadow-sm mb-2 border-0">
                                                <div class="card-header background-primary">
                                                    <div class="row align-items-center">
                                                        <div class="col-auto pr-0" v-if="profile.isAdmin || (profile.isEmployee && (profile.employee.isDirector || profile.employee.isManager || profile.employee.isMentor || profile.employee.isBranchStaff))">
                                                            <router-link v-bind:to="{name: 'student/tryout/view', params: {id: student.userID, tryoutID: tryout.id}}" class="btn btn-sm btn-outline-light font-weight-light h6 mb-0">
                                                                Analisis
                                                            </router-link>
                                                        </div>
                                                        <div class="col">
                                                            <h4 class="font-weight-bold text-white mb-0">
                                                                Pengumuman {{ tryout.name }}
                                                            </h4>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row grid">
                                        <template v-if="typeof tryout.tryoutGroups !== typeof undefined">
                                            <div class="col">
                                                <div class="card shadow-sm mb-2 border-0">
                                                    <div class="card-header background-primary text-white px-2 py-1">
                                                        <div class="row">
                                                            <div class="col height-2">
                                                                <h4 class="mb-0 text-center py-4">
                                                                    Jumlah
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card-body p-2">
                                                        <div class="row">
                                                            <div class="col height-1">
                                                                Benar
                                                            </div>
                                                        </div>
                                                        <div class="row">
                                                            <div class="col height-1">
                                                                Salah
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <template v-for="(tryoutGroup, index) in tryout.tryoutGroups">
                                                <div class="col-auto">
                                                    <div class="row">
                                                        <div class="col">
                                                            <div class="card shadow-sm mb-2 border-0">
                                                                <div class="card-header height-1 px-2 rounded" v-bind:class="classStyles[index % classStyles.length]">
                                                                    <div class="row">
                                                                        <div class="col">
                                                                            <h4 class="mb-0 text-center">
                                                                                {{ tryoutGroup.groupSubject.name }} ({{ tryoutGroup.code }})
                                                                            </h4>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-auto" v-for="tryoutSubject in tryoutGroup.tryoutSubjects">
                                                            <div class="card shadow-sm mb-2 border-0">
                                                                <div class="card-header height-1 px-2" v-bind:class="classStyles[index % classStyles.length]">
                                                                    <div class="row">
                                                                        <div class="col width-2">
                                                                            <h4 class="mb-0 text-center">
                                                                                {{ tryoutSubject.subject.shortname }}
                                                                            </h4>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="card-body p-2">
                                                                    <div class="row">
                                                                        <div class="col text-center height-1">
                                                                            {{ tryoutSubject.subjectScores[0] ? tryoutSubject.subjectScores[0].correctAnswer : 0 }}
                                                                        </div>
                                                                    </div>
                                                                    <div class="row">
                                                                        <div class="col text-center height-1">
                                                                            {{ tryoutSubject.subjectScores[0] ? tryoutSubject.subjectScores[0].wrongAnswer : 0 }}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-for="(tryoutGroup, index) in tryout.tryoutGroups">
                                                <template v-if="typeof tryoutGroup.groupScores !== typeof undefined && tryoutGroup.groupScores[0]">
                                                    <div class="col-auto">
                                                        <div class="card shadow-sm mb-2 border-0">
                                                            <div class="card-header background-primary text-white px-2 py-1">
                                                                <div class="row">
                                                                    <div class="col height-2">
                                                                        <h4 class="mb-0 text-center py-2">
                                                                            <!-- <i class="fa fa-percent"></i> -->
																																							SKOR
                                                                        </h4>
                                                                        <h4 class="mb-0 text-center py-2">
                                                                            {{ tryoutGroup.groupSubject.name }}
                                                                        </h4>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="card-body p-2">
                                                                <div class="row">
                                                                    <div class="col text-center height-2 py-3">
                                                                        {{ tryoutGroup.groupScores[0].percentage }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                        <div class="col-auto">
                                                            <div class="card shadow-sm mb-2 border-0">
                                                                <div class="card-header background-primary text-white px-2 py-1">
                                                                    <div class="row">
                                                                        <div class="col height-2">
                                                                            <h4 class="mb-0 text-center py-4">
                                                                                <i class="fa fa-trophy"></i>
                                                                            </h4>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="card-body p-2">
                                                                    <div class="row">
                                                                        <div class="col height-2 py-1">
                                                                            <h4 class="mb-0 text-center">
                                                                                <div>{{ tryoutGroup.rank }}</div>
                                                                                <div>dari</div>
                                                                                <div>{{ tryoutGroup.totalStudent }}</div>
                                                                            </h4>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    
                                                </template>
                                            </template>

											<div class="col-auto">
                                                <div class="card shadow-sm mb-2 border-0">
                                                    <div class="card-header background-primary text-white px-2 py-1">
                                                        <div class="row">
                                                            <div class="col height-2">
                                                                <h4 class="mb-0 text-center py-4">
                                                                    <i class="fa fa-file-text-o"></i>
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card-body p-2">
                                                        <div class="row">
                                                            <div class="col height-2 py-1">
                                                                <h4 class="mb-0" v-html="note(tryout)"></h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="col-auto" v-for="(tryoutSubject, index) in tryout.tryoutSubjects">
                                                <div class="card shadow-sm mb-2 border-0">
                                                    <div class="card-header height-2 px-2 py-1" v-bind:class="classStyles[index % classStyles.length]">
                                                        <div class="row">
                                                            <div class="col width-2 py-3">
                                                                <h4 class="mb-0 text-center">
                                                                    {{ tryoutSubject.subject.shortname }}
                                                                </h4>
                                                                <h4 class="mb-0 text-center">
                                                                    ({{ tryoutSubject.code }})
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card-body p-2">
                                                        <div class="row">
                                                            <div class="col text-center height-2 py-3">
                                                                {{ tryoutSubject.subjectScores[0] ? tryoutSubject.subjectScores[0].score : 0 }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-auto">
                                                <div class="card shadow-sm mb-2 border-0">
                                                    <div class="card-header background-primary text-white px-2 py-1">
                                                        <div class="row">
                                                            <div class="col height-2">
                                                                <h4 class="mb-0 text-center py-4">
                                                                    Total Nilai
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card-body p-2">
                                                        <div class="row">
                                                            <div class="col text-center height-2 py-3">
                                                                {{ tryout.totalScore }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                           	<div class="col-auto">
                                                <div class="card shadow-sm mb-2 border-0">
                                                    <div class="card-header background-primary text-white px-2 py-1">
                                                        <div class="row">
                                                            <div class="col height-2">
                                                                <h4 class="mb-0 text-center py-4">
                                                                    <i class="fa fa-trophy"></i>
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                   <div class="card-body p-2">
                                                        <div class="row">
                                                            <div class="col height-2 py-1">
                                                                <h4 class="mb-0 text-center">
                                                                    <div>{{ tryout.rank }}</div>
                                                                    <div>dari</div>
                                                                    <div>{{ tryout.totalStudent }}</div>
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div> 
                                                </div>
                                            </div> 
                                            <div class="col-auto">
                                                <div class="card shadow-sm mb-2 border-0">
                                                    <div class="card-header background-primary text-white px-2 py-1">
                                                        <div class="row">
                                                            <div class="col height-2">
                                                                <h4 class="mb-0 text-center py-4">
                                                                    <i class="fa fa-file-text-o"></i>
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card-body p-2">
                                                        <div class="row">
                                                            <div class="col height-2 py-1">
                                                                <h4 class="mb-0" v-html="note(tryout)"></h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import IEcharts from 'vue-echarts-v3/src/full.js';
    import { dragscroll } from 'vue-dragscroll';
    import { semesters } from '@/params.js';

    export default {
        name: "StudentScore",
        directives: {dragscroll},
        components: {
            IEcharts: IEcharts
        },
        computed: mapState([
            'profile'
        ]),
        data() {
            let colors = ['#38EF7D', '#88429B', '#FEC401', '#d31027', '#00ADEF', '#FE8200'];
            return {
                student: {user: {}, branch: {}, school: {}, btaGrade: {}},
                tryouts: [],
		logs: [],
                courseCategories: [],
                statuses: [],
                semesters: semesters,
                classStyles: ['bg-warning', 'bg-success', 'bg-info text-white'],
                graphData: {
                    bar: {
                        color: ['#00ADEF', '#d31027', '#38EF7D'],
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {type: 'shadow'},
                            formatter: function (params) {
                                let string = params[0].name + '<br />';
                                for (let i = 0; i < params.length; i++) {
                                    let param = params[i];
                                    if (param.seriesIndex < 3 && isNaN(param.name)) {
                                        string += param.marker + param.seriesName + ': ' + param.value + '<br />';
                                    }
                                }
                                return string;
                            }
                        },
                        legend: {
                            left: 'center',
                            top: 'bottom',
                            itemWidth: 12,
                            itemHeight: 12,
                            textStyle: {padding: [0, 10, 0, 0], fontFamily: 'Ubuntu-Regular', fontSize: 14},
                            data: [
                                {name: 'Nilai Siswa', icon: 'circle'},
                                {name: 'Nilai Rata-Rata', icon: 'circle'},
                                {name: 'Nilai Tertinggi', icon: 'circle'}
                            ]
                        },
                        grid: {
                            left: '1%',
                            right: '1%',
                            containLabel: true
                        },
                        yAxis: {
                            min: 0,
                            axisLabel: {fontSize: 14, fontFamily: 'Ubuntu-Medium'},
                            axisLine: {show: false},
                            axisTick: {show: false}
                        },
                        xAxis: [
                            {
                                type: 'category',
                                data: [],
                                axisLine: {show: false},
                                axisTick: {show: false},
                                axisLabel: {
                                    rotate: 20,
                                    margin: 15,
                                    interval: 0,
                                    textStyle: {fontSize: 14, fontFamily: 'Ubuntu-Bold'}
                                }
                            },
                            {
                                type: 'category',
                                data: [],
                                axisLabel: {
                                    show: false
                                }
                            }
                        ],
                        series: [
                            {
                                name: 'Nilai Siswa',
                                zlevel: 2,
                                type: 'bar',
                                itemStyle: {
                                    barBorderRadius: [50, 50, 0, 0]
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                                    fontSize: 14,
                                    fontFamily: 'Ubuntu-Bold',
                                    offset: [0, -5]
                                },
                                barGap: '50%',
                                barCategoryGap: '30%',
                                data: []
                            },
                            {
                                type: 'bar',
                                zlevel: 2,
                                name: 'Nilai Rata-Rata',
                                itemStyle: {
                                    barBorderRadius: [50, 50, 0, 0]
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                                    fontSize: 14,
                                    fontFamily: 'Ubuntu-Bold',
                                    offset: [0, -5]
                                },
                                data: []
                            },
                            {
                                type: 'bar',
                                zlevel: 2,
                                name: 'Nilai Tertinggi',
                                itemStyle: {
                                    barBorderRadius: [50, 50, 0, 0]
                                },
                                label: {
                                    show: true,
                                    position: 'top',
                                    fontSize: 14,
                                    fontFamily: 'Ubuntu-Bold',
                                    offset: [0, -5]
                                },
                                data: []
                            },
                            /**
                             * Bar placeholder
                             */
                            {
                                name: 'Nilai Siswa',
                                type: 'bar',
                                xAxisIndex: 1,
                                zlevel: 1,
                                barGap: '50%',
                                barCategoryGap: '30%',
                                itemStyle: {
                                    color: 'rgba(0,0,0,0.05)',
                                    barBorderRadius: [50, 50, 0, 0]
                                },
                                data: []
                            },
                            {
                                name: 'Nilai Rata-Rata',
                                type: 'bar',
                                xAxisIndex: 1,
                                zlevel: 1,
                                itemStyle: {
                                    color: 'rgba(0,0,0,0.05)',
                                    barBorderRadius: [50, 50, 0, 0]
                                },
                                data: []
                            },
                            {
                                name: 'Nilai Tertinggi',
                                type: 'bar',
                                xAxisIndex: 1,
                                zlevel: 1,
                                itemStyle: {
                                    color: 'rgba(0,0,0,0.05)',
                                    barBorderRadius: [50, 50, 0, 0]
                                },
                                data: []
                            }
                        ]
                    },
                    donuts: [
                        {
                            title: {show: false},
                            tooltip: {
                                show: true,
                                formatter: function (param) {
                                    return param.seriesName + '<br />' + param.marker + param.name + ': ' + param.value + '%';
                                }
                            },
                            legend: {
                                orient: 'vertical',
                                align: 'left',
                                left: 'right',
                                top: 'middle',
                                itemWidth: 15,
                                itemHeight: 15,
                                textStyle: {padding: [0, 0, 5, 10], fontFamily: 'Ubuntu-Regular', fontSize: 14},
                                data: []
                            },
                            series: [
                                {
                                    name: '',
                                    type: 'pie',
                                    radius: ['50%', '65%'],
                                    center: ['35%', '50%'],
                                    itemStyle: {
                                        color: function (params) {
                                            return colors[params.dataIndex % colors.length];
                                        },
                                        barBorderRadius: [25, 25, 0, 0]
                                    },
                                    label: {
                                        show: true,
                                        position: 'top',
                                        fontSize: 14,
                                        fontFamily: 'Ubuntu-Bold',
                                        formatter: function (item) {
                                            return item.value + '%';
                                        }
                                    },
                                    data: []
                                }
                            ]
                        },
                        {
                            title: {show: false},
                            tooltip: {
                                show: true,
                                formatter: function (param) {
                                    return param.seriesName + '<br />' + param.marker + param.name + ': ' + param.value + '%';
                                }
                            },
                            legend: {
                                orient: 'vertical',
                                align: 'left',
                                left: 'right',
                                top: 'middle',
                                itemWidth: 15,
                                itemHeight: 15,
                                textStyle: {padding: [0, 0, 5, 10], fontFamily: 'Ubuntu-Regular', fontSize: 14},
                                data: []
                            },
                            series: [
                                {
                                    name: '',
                                    type: 'pie',
                                    radius: ['50%', '65%'],
                                    center: ['35%', '50%'],
                                    itemStyle: {
                                        color: function (params) {
                                            return colors[params.dataIndex % colors.length];
                                        },
                                        barBorderRadius: [25, 25, 0, 0]
                                    },
                                    label: {
                                        show: true,
                                        position: 'top',
                                        fontSize: 14,
                                        fontFamily: 'Ubuntu-Bold',
                                        formatter: function (item) {
                                            return item.value + '%';
                                        }
                                    },
                                    data: []
                                }
                            ]
                        },
                        {
                            title: {show: false},
                            tooltip: {
                                show: true,
                                formatter: function (param) {
                                    return param.seriesName + '<br />' + param.marker + param.name + ': ' + param.value + '%';
                                }
                            },
                            legend: {
                                orient: 'vertical',
                                align: 'left',
                                left: 'right',
                                top: 'middle',
                                itemWidth: 15,
                                itemHeight: 15,
                                textStyle: {padding: [0, 0, 5, 10], fontFamily: 'Ubuntu-Regular', fontSize: 14},
                                data: []
                            },
                            series: [
                                {
                                    name: '',
                                    type: 'pie',
                                    radius: ['50%', '65%'],
                                    center: ['35%', '50%'],
                                    itemStyle: {
                                        color: function (params) {
                                            return colors[params.dataIndex % colors.length];
                                        },
                                        barBorderRadius: [25, 25, 0, 0]
                                    },
                                    label: {
                                        show: true,
                                        position: 'top',
                                        fontSize: 14,
                                        fontFamily: 'Ubuntu-Bold',
                                        formatter: function (item) {
                                            return item.value + '%';
                                        }
                                    },
                                    data: []
                                }
                            ]
                        }
                    ]
                }
            };
        },
        methods: {
            print() {
                alert('Not Implemented');
            },
            isMobile() {
                return 'ontouchstart' in window || navigator.msMaxTouchPoints;
            },
            addBarData(name, value, average, max) {
                this.graphData.bar.xAxis[0].data.push(name);
                this.graphData.bar.xAxis[1].data.push(name);
                this.graphData.bar.series[0].data.push(value);
                this.graphData.bar.series[1].data.push(average);
                this.graphData.bar.series[2].data.push(max);
                for (let placeholder = 3; placeholder <= 5; placeholder++) {
                    this.graphData.bar.series[placeholder].data.push(100);
                }
            },
            addDonutData(index, name, value) {
                if (this.graphData.donuts[index]) {
                    this.graphData.donuts[index].legend.data.push({name: name, icon: 'circle'});
                    this.graphData.donuts[index].series[0].data.push({name: name, value: value});
                }
            },
            roleElligibleView() {
                return this.profile.isAdmin || (this.profile.isEmployee && (this.profile.employee.isDirector || this.profile.employee.isManager || this.profile.employee.isBranchStaff || this.profile.employee.isBranchHead));
            },
            resize() {
                let width = window.innerWidth || document.documentElement.clientWidth;
                for (let i = 0; i < this.graphData.donuts.length; i++) {
                    if (width < 1200) {
                        this.graphData.donuts[i].legend.orient = 'horizontal';
                        this.graphData.donuts[i].legend.left = 'center';
                        this.graphData.donuts[i].legend.top = 'bottom';

                        this.graphData.donuts[i].series[0].center = ['50%', '40%'];
                    } else {

                        this.graphData.donuts[i].legend.orient = 'vertical';
                        this.graphData.donuts[i].legend.left = 'right';
                        this.graphData.donuts[i].legend.top = 'middle';

                        this.graphData.donuts[i].series[0].center = ['35%', '50%'];
                    }
                }
            },
            note(tryout) {
                let notes = [];
                if (typeof tryout.tryoutGroups !== typeof undefined && tryout.tryoutGroups.length) {
                    notes = tryout.tryoutGroups.map(tryoutGroup => tryoutGroup.groupScores.length ? (tryoutGroup.groupScores[0].note || '') : '');
                } else {
                    notes = tryout.tryoutSubjects.map(tryoutSubject => tryoutSubject.subjectScores.length ? (tryoutSubject.subjectScores[0].note || '') : '');
                }
                return notes.join('<br />');
            },
            fetchStudent() {
                this.axios.get(process.env.API_URL + '/student/' + this.student.userID).then(response => {
                    if (response.data.status) {
                        let attendanceReports = response.data.data.uploadedAttendanceReports;
                        for (let i = 0; i < this.semesters.length; i++) {
                            this.graphData.donuts[i].series[0].name = this.semesters[i].name;
                            let attendanceReport = attendanceReports[i];
                            if (attendanceReport) {
                                this.graphData.donuts[i].legend.data = [];
                                this.graphData.donuts[i].series[0].data = [];
                                for (let index in this.statuses) {
                                    this.addDonutData(i, this.statuses[index].name, attendanceReport.values[this.statuses[index].name]);
                                }
                            }
                        }
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/student/scores/' + this.$route.params.id),
                this.axios.get(process.env.API_URL + '/course-category'),
                this.axios.get(process.env.API_URL + '/attendance-status')
            ]).then(this.axios.spread(function (responseScore, responseCourseCategory, responseStatus) {
                this.student = responseScore.data.data.student;
                this.tryouts = responseScore.data.data.tryouts;
                this.courseCategories = responseCourseCategory.data.data;
                this.statuses = responseStatus.data.data;

                for (let i = 0; i < this.tryouts.length; i++) {
                    let tryout = this.tryouts[i];
                    if (typeof tryout.tryoutGroups !== typeof undefined) {
                        for (let j = 0; j < tryout.tryoutGroups.length; j++) {
                            let tryoutGroup = tryout.tryoutGroups[j];
                            if (tryoutGroup.groupScores.length) {
                                this.addBarData(tryout.name + '\n' + tryoutGroup.groupSubject.name, tryoutGroup.groupScores[0].percentage, tryoutGroup.average, tryoutGroup.maxScore);
                            }
                        }
                    } else {
                        this.addBarData(tryout.name, tryout.totalScore, tryout.average, tryout.maxScore);
                    }
                }

                this.fetchStudent();

                document.title = 'Laporan Nilai Siswa ' + this.student.user.name + ' - ' + process.env.APP_NAME;
            }.bind(this)));
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.resize);
                this.resize();
            });
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.resize);
        }
    };
</script>

<style scoped>
    .width-1 { min-width: 2rem; }
    .width-2 { min-width: 4.5rem; }
    .height-1 { min-height: 2rem; }
    .card-header.height-2 { min-height: 4.5rem; }
    .height-2:not(.card-header) { min-height: 4.05rem; }

    .graph-wrapper .donut-chart { height: 240px; }
    @media (max-width: 1199.98px) {
        .graph-wrapper .donut-chart { height: 300px; }
    }
</style>


// WEBPACK FOOTER //
// src/components/student/Score.vue